import React from 'react';

export default function Loading() {
  return (
    <>
      {Array.from({ length: 7 }, (_, index) => (
        <div
          key={index}
          className="group no-underline block bg-white w-full pb-8 mb-8 last:pb-0 last:mb-0 not-last:border-b not-last:border-gray-950/10 animate-pulse"
        >
          <div className="flex gap-3 items-center mb-6">
            <div className="w-4.5 h-4.5 bg-grey-200" />
            <div className="w-10 h-4.5 bg-grey-200" />
          </div>
          <div className="mb-6 w-92 h-6 bg-grey-300" />
          <div className="flex flex-col items-start justify-start relative w-full">
            <div className="w-full h-4.5 bg-grey-300 mb-4.5" />
            <div className="w-19/20 h-4.5 bg-grey-300 mb-4.5" />
            <div className="w-full h-4.5 bg-grey-300 mb-4.5" />
            <div className="w-3/5 h-4.5 bg-grey-300 mb-4.5" />
            <div className="underline group-hover:no-underline font-bold bg-blue-dark-1 w-62.5 h-4.5" />
          </div>
        </div>
      ))}
    </>
  );
}
